import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'

Vue.use(VueRouter)

// Roles de usuario definidos en components/backend/taquilleros/FormComponent.vue
const ROLE_TAQUILLERO_VISITANTE = 11;

// El taquillero de la taquilla del club visitante no debe acceder a secciones
// del equipo local (dashboard, control de acceso). Redirige al listado de eventos.
function blockTaquilleroVisitante(to, from, next) {
    const user = store.getters.getUser;
    if (user) {
        if (user.role === ROLE_TAQUILLERO_VISITANTE) {
            next({ name: 'back.events.index' });
        } else {
            next();
        }
        return;
    }
    // Carga directa por URL: los datos del usuario llegan de forma asíncrona
    // (acción CHECK en AppLoader.vue), así que esperamos a que se pueblen
    // antes de decidir, igual que hace el redirect de /admin con el footer.
    const unwatch = store.watch(
        (state, getters) => getters.getUser,
        newUser => {
            if (!newUser) {
                return;
            }
            unwatch();
            if (newUser.role === ROLE_TAQUILLERO_VISITANTE) {
                next({ name: 'back.events.index' });
            } else {
                next();
            }
        }
    );
}

const routes = [
    {
        path : '/',
        component : () => import(/* webpackChunkName: "web" */ '@/views/frontend/home/Home.vue'),
        name: 'front.home',
        head() {
            return {
                meta: [
                    {
                        name: 'canonical',
                        content: `${process.env.BASE_URL}/`
                    }
                ]
            };
        }
    },
    {
        path : '/mantenimiento',
        component : () => import('@/views/frontend/mantenimiento/Index.vue'),
        name: 'front.mantenimiento'
    },
    {
        path : '/queue',
        component : () => import('@/views/frontend/queue/index'),
        name: "front.queue",
        props: true
    },
    {
        path : '/',
        component : () => import(/* webpackChunkName: "web" */ '@/views/frontend/FrontEnd.vue'),
        children : [
            {
                path : 'mi-abono',
                component : () => import(/* webpackChunkName: "web" */ '@/views/frontend/mi_abono/FrontMiAbono.vue'),
                children : [
                    {
                        path : '',
                        component : () => import(/* webpackChunkName: "web" */ '@/views/frontend/mi_abono/Index.vue'),
                        name: 'mi-abono',
                        props: true
                    },
                    {
                        path : 'cambio-asiento',
                        component : () => import(/* webpackChunkName: "web" */ '@/views/frontend/mi_abono/CambiarAsiento.vue'),
                        name: 'mi-abono.cambio-asiento',
                        props: true
                    },
                ]
            },
            {
                path : 'perfil',
                component : () => import(/* webpackChunkName: "web" */ '@/views/frontend/perfil/FrontendPerfil.vue'),
                beforeEnter: (to, from, next) => {
                    // /perfil requiere login. Si no hay token, redirigimos a login.
                    // Esto cubre /perfil y todos sus children (plazos, liberar-asiento,
                    // ceder-asiento, etc.) porque Vue Router 3 ejecuta el beforeEnter del
                    // padre para cualquier navegación a un child. Sin este guard, los
                    // componentes legacy (Perfil.vue, PerfilSga.vue) hacían
                    // dispatch(...).then(...) sin catch, así que la promesa fallaba
                    // silenciosamente con 403 y la página quedaba en loading infinito.
                    const token = typeof localStorage !== 'undefined' && localStorage.getItem('token');
                    if (!token || token === 'null' || token === 'undefined') {
                        next({ name: 'login' });
                    } else {
                        next();
                    }
                },
                children: [
                    {
                        path: '',
                        component : () => import(/* webpackChunkName: "web" */ '@/views/frontend/perfil/Index.vue'),
                        name: 'perfil'
                    },
                    {
                        path: ':tipo_plazo/:tipo_id/plazos',
                        component : () => import(/* webpackChunkName: "web" */ '@/views/frontend/perfil/plazos/Plazos.vue'),
                        name: 'plazos',
                        props: true
                    },
                    {
                        path: 'abono/:abono_id/liberar-asiento',
                        component : () => import(/* webpackChunkName: "web" */ '@/views/frontend/perfil/liberar_asientos/LiberarAsiento.vue'),
                        name: 'liberar-asiento'
                    },
                    {
                        path: 'abono/:abono_id/liberar-asiento/:evento_id',
                        component : () => import(/* webpackChunkName: "web" */ '@/views/frontend/perfil/liberar_asientos/sesiones/LiberarAsientosSesiones.vue'),
                        name: 'liberar-asiento-sesion',
                    },
                    {
                        path: 'abono/:abono_id/ceder-asiento',
                        component : () => import(/* webpackChunkName: "web" */ '@/modules/front/perfil/views/CederAsiento.vue'),
                        name: 'ceder-asiento'
                    },
                    {
                        path: 'abono/:abono_id/ceder-asiento/:evento_id/:sesion_id',
                        component : () => import(/* webpackChunkName: "web" */ '@/modules/front/perfil/views/CederAsientoDetalle.vue'),
                        name: 'ceder-asiento-detalle'
                    },
                    {
                        path: 'abono/:abono_id/invitaciones',
                        component : () => import(/* webpackChunkName: "web" */ '@/views/frontend/perfil/invitaciones/Invitaciones.vue'),
                        name: 'invitaciones',
                        props: true
                    },
                    {
                        path : 'abono/:abono_id/invitaciones/:event_id/:sesion_id',
                        component : () => import(/* webpackChunkName: "web" */ '@/views/frontend/perfil/invitaciones_generar/InvitacionesEventos.vue'),
                        name: 'invitaciones-generar',
                        props: true
                    },
                    {
                        path : ':tpv_order',
                        component : () => import(/* webpackChunkName: "web" */ '@/views/frontend/perfil/pedido/DetallePedido.vue'),
                        name: 'cambiar-datos-entradas',
                        props: true
                    },
                ]
            },
            {
                path : 'login',
                component : () => import(/* webpackChunkName: "web" */ '@/modules/front/login/views/Login.vue'),
                name: 'login'
            },
            {
                path : 'register',
                component : () => import(/* webpackChunkName: "web" */ '@/modules/front/login/views/Register.vue'),
                name: 'register'
            },
            {
                path : 'forgot-password',
                component : () => import(/* webpackChunkName: "web" */ '@/modules/front/login/views/ForgotPassword.vue'),
                name: 'forgot-password'
            },
            {
                path : 'forgot-password/change',
                component : () => import(/* webpackChunkName: "web" */ '@/modules/front/login/views/ResetPassword.vue'),
                name: 'reset-password'
            },
            {
                path : 'aviso-legal',
                component : () => import('@/views/frontend/legal/Index.vue'),
                name: 'legal'
            },
            {
                path : 'aviso-legal-preventa/:eventoId?',
                component : () => import('@/views/frontend/legal/preventa/Index.vue'),
                name: 'legal-preventa'
            },
            {
                path : 'aviso-de-privacidad',
                component : () => import('@/views/frontend/privacidad/Index.vue'),
                name: 'privacidad'
            },
            {
                path : 'condiciones-generales',
                component : () => import('@/views/frontend/condiciones_generales/Index.vue'),
                name: 'condiciones_generales'
            },
            {
                path : 'email/baja',
                component : () => import(/* webpackChunkName: "web" */ '@/views/frontend/baja_emails/Index.vue'),
                name: 'email_baja'
            },

            {
                path : 'compra/:session_id/:tpv_order',
                component : () => import(/* webpackChunkName: "web" */ '@/views/frontend/events/CompraFinalizada'),
                name: 'compra.finalizada',
                props: true
            },
            {
                path : 'webhooks/paycomet/instant-credit/:order/return/:result',
                component : () => import(/* webpackChunkName: "web" */ '@/views/frontend/compra/InstantCreditReturn.vue'),
                name: 'instant-credit.return',
                props: true
            },
            {
                path : 'compra-parcelas/:session_id/:n_pedido',
                component : () => import(/* webpackChunkName: "web" */ '@/views/frontend/parcelas/CompraFinalizada'),
                name: 'compra-parcelas.finalizada',
                props: true
            },
            {
                path : 'compra-lfp/:session_id/:n_pedido',
                component : () => import(/* webpackChunkName: "web" */ '@/views/frontend/sga/CompraFinalizada'),
                name: 'compra-lfp.finalizada',
                props: true
            },
            {
                path : 'compra/error-compra',
                component : () => import(/* webpackChunkName: "web" */ '@/views/frontend/compra/ErrorCompra'),
                name: 'compra.error',
            },
            {
                path : 'afiliados',
                component : () => import(/* webpackChunkName: "web" */ '@/views/frontend/afiliados/Afiliados.vue'),
                children : [
                    {
                        path : '',
                        component : () => import(/* webpackChunkName: "web" */ '@/views/frontend/afiliados/Index.vue'),
                        name: 'front.afiliados.index'
                    }
                ]
            },
            {
                path : 'eventos',
                component : () => import(/* webpackChunkName: "web" */ '@/views/frontend/events/FrontEvents.vue'),
                children : [
                    {
                        path : '',
                        component : () => import(/* webpackChunkName: "web" */ '@/modules/front/events/views/EventList.vue'),
                        name: 'front.eventos.index'
                    },
                    {
                        path : ':event_id/',
                        component : () => import(/* webpackChunkName: "web" */ '@/views/frontend/events/layouts/show/SesionesEvento.vue'),
                        name: 'front.eventos.sesiones',
                        props: true
                    },
                    {
                        path : ':event_id/:sesion_id',
                        component : () => import(/* webpackChunkName: "web" */ '@/views/frontend/events/Show.vue'),
                        name: 'front.eventos.show',
                        props: true
                    },
                    {
                        path : ':event_id/:sesion_id/registro-preventa',
                        component : () => import(/* webpackChunkName: "web" */ '@/views/frontend/events/registro-preventa/RegistroPreventa.vue'),
                        name: 'front.eventos.registro-preventa',
                        props: true
                    },
                    {
                        path : ':event_id/:sesion_id/abonados',
                        component : () => import(/* webpackChunkName: "web" */ '@/views/frontend/events/ShowAbonados.vue'),
                        name: 'front.eventos.show.abonados',
                        props: true
                    },
                    {
                        path : ':event_id/:sesion_id/amigos-abonados',
                        component : () => import(/* webpackChunkName: "web" */ '@/views/frontend/events/ShowAbonados.vue'),
                        name: 'front.eventos.show.amigosabonados',
                        props: true
                    },
                    {
                        path : ':event_id/:sesion_id/:slug',
                        component : () => import(/* webpackChunkName: "web" */ '@/views/frontend/events/Show.vue'),
                        name: 'front.eventos.show.slug',
                        props: true
                    },
                ]
            },
            {
                path : 'productos',
                component : () => import(/* webpackChunkName: "web" */ '@/views/frontend/productos/Productos.vue'),
                children : [
                    {
                        path : '',
                        component : () => import(/* webpackChunkName: "web" */ '@/views/frontend/productos/Index.vue'),
                        name: 'front.productos.index'
                    },
                    {
                        path : ':slug/sesiones',
                        component : () => import(/* webpackChunkName: "web" */ '@/views/frontend/productos/sesiones/Index.vue'),
                        name: 'front.productos.sesiones',
                        props: true
                    },
                    {
                        path : ':slug/:sesion_id',
                        component : () => import(/* webpackChunkName: "web" */ '@/views/frontend/productos/Show.vue'),
                        name: 'front.productos.show',
                        props: true
                    }
                ]
            },
            {
                path : 'experiencias',
                component : () => import(/* webpackChunkName: "web" */ '@/modules/front/experiencias/views/ExperienciaList.vue'),
                name: 'front.experiencias.index'
            },
            {
                path : 'packs-eventos',
                component : () => import(/* webpackChunkName: "web" */ '@/views/frontend/packs/PackEvents.vue'),
                children : [
                    {
                        path : '',
                        component : () => import(/* webpackChunkName: "web" */ '@/views/frontend/packs/Index.vue'),
                        name: 'front.packs.index'
                    },
                    {
                        path : ':slug',
                        component : () => import(/* webpackChunkName: "web" */ '@/views/frontend/packs/Show.vue'),
                        name: 'front.packs.show',
                        props: true
                    }
                ]
            },
            {
                path : 'faqs',
                component : () => import(/* webpackChunkName: "web" */ '@/views/frontend/preguntas/FrontPreguntas.vue'),
                children: [
                    {
                        path: '',
                        component : () => import(/* webpackChunkName: "web" */ '@/views/frontend/preguntas/Index.vue'),
                        name : 'front.faqs.index'
                    },
                    {
                        path : ':faq_id',
                        component : () => import(/* webpackChunkName: "web" */ '@/views/frontend/preguntas/Show.vue'),
                        name: 'front.faqs.show',
                        props: true
                    }
                ]
            },
            {
                path : 'abonos',
                component : () => import(/* webpackChunkName: "web" */ '@/views/frontend/abonos/FrontAbonos'),
                children : [
                    {
                        path : 'nuevo',
                        component : () => import(/* webpackChunkName: "web" */ '@/views/frontend/abonos/nuevo/Index'),
                        name: 'front.abonos.nuevo.index'
                    },
                    {
                        path : 'renovar',
                        component : () => import(/* webpackChunkName: "web" */ '@/views/frontend/abonos/renovar/Index'),
                        name: 'front.abonos.renovar.index'
                    },
                    {
                        path : 'buscar-abonado',
                        component : () => import(/* webpackChunkName: "web" */ '@/modules/front/sga/abonos/views/BuscarYRegistrarAbonado.vue'),
                        name: 'front.abonos.buscar-abonado'
                    }
                ]
            },
            {
                path : 'simpatizantes',
                component : () => import(/* webpackChunkName: "web" */ '@/views/frontend/simpatizantes/FrontSimpatizantes.vue'),
                children : [
                    {
                        path : '',
                        component : () => import(/* webpackChunkName: "web" */ '@/views/frontend/simpatizantes/Index.vue'),
                        name: 'front.simpatizantes.index'
                    }
                ]
            },
            {
                path : 'cantera',
                component : () => import(/* webpackChunkName: "web" */ '@/views/frontend/bases/FrontBases.vue'),
                children : [
                    {
                        path : '',
                        component : () => import(/* webpackChunkName: "web" */ '@/views/frontend/bases/Index.vue'),
                        name: 'front.bases.index'
                    },
                    {
                        path : 'nueva',
                        component : () => import(/* webpackChunkName: "web" */ '@/views/frontend/bases/Crear.vue'),
                        name: 'front.bases.crear'
                    },
                    {
                        path : 'renovar',
                        component : () => import(/* webpackChunkName: "web" */ '@/views/frontend/bases/Renovar.vue'),
                        name: 'front.bases.renovar'
                    },
                    {
                        path : 'compra/:session_id/:tpv_order',
                        component : () => import(/* webpackChunkName: "web" */ '@/views/frontend/bases/CompraFinalizada'),
                        name: 'cantera.compra.finalizada',
                        props: true
                    },
                ]
            },
            {
                path: 'ayuda',
                component: () => import('@/views/frontend/ayuda/ayuda.vue'),
                name: 'ayuda'
            },
            {
                path : 'error',
                component : () => import('@/views/frontend/ErrorInterno'),
                name: "front.error",
            },
            {
                path: 'reservas/:hash',
                component: () => import('@/views/frontend/reservas/Reservas'),
                name: 'reservas',
                props: true
            },
            {
                path : 'acreditaciones',
                component : () => import('@/views/frontend/acreditaciones/index.vue'),
                name: 'front.acreditacion',
                props: true
            },
            {
                path : 'carrito',
                component : () => import('@/views/frontend/carrito/Index.vue'),
                name: 'front.carrito'
            },
            {
                path : 'parcelas',
                component : () => import('@/views/frontend/parcelas/Index.vue'),
                name: 'front.parcelas'
            }
        ]
    },
    {
        path : '/admin',
        component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/BackEnd.vue'),
        beforeEnter: (to, from, next) => {
            if(to.query.api_key) {
                localStorage.setItem('token', to.query.api_key);
                store.commit('setUserToken', to.query.api_key);
                store.commit('setIsLogged', true);
            }

            if (localStorage.getItem('token') != null) {
                store.commit('setUserToken', localStorage.getItem('token'));
                store.commit('setIsLogged', true);
            }

            if (store.getters.isLogged) {
                next();
            } else {
                next('/');
            }
        },
        children : [
            {
                // Redirección desde /admin según el tipo de manager:
                // - tipo 1 (deportivo) → Venta de abonos
                // - tipo 2 (teatro)    → Eventos
                // Se ignora el flag `manager.ocultar_abonos` aquí porque la
                // opción de Venta de abonos en el aside se muestra siempre
                // que el manager tenga los permisos `abonos.vender` /
                // `abonos.informe`.
                //
                // El footer se carga de forma asíncrona desde AppLoader.vue
                // (acción SETTINGS), así que si el usuario entra a /admin
                // antes de que llegue, esperamos a que se pueble antes de
                // decidir el destino.
                //
                // Se usa beforeEnter (no redirect) porque vue-router 3.x
                // no soporta Promises en `redirect` y necesitamos esperar
                // al footer de forma asíncrona.
                path : '',
                beforeEnter: (to, from, next) => {
                    const footer = store.getters.getFooter;
                    if (footer) {
                        if (footer.tipo === 1) {
                            next({ name: 'back.abonos.index' });
                        } else {
                            next({ name: 'back.events.index' });
                        }
                        return;
                    }
                    const unwatch = store.watch(
                        (state, getters) => getters.getFooter,
                        newFooter => {
                            if (newFooter) {
                                unwatch();
                                if (newFooter.tipo === 1) {
                                    next({ name: 'back.abonos.index' });
                                } else {
                                    next({ name: 'back.events.index' });
                                }
                            }
                        }
                    );
                }
            },
            {
                path : 'dashboard',
                component : () => import(/* webpackChunkName: "admin" */ '@/modules/admin/dashboard/views/Dashboard.vue'),
                name: 'back.dashboard.club',
                beforeEnter: blockTaquilleroVisitante
            },
            {
                path : 'test-datafono',
                component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/test-datafono/Index.vue'),
                name: 'back.test-datafono'
            },
            {
                path : 'carrito',
                component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/carrito/Index.vue'),
                name: 'back.carrito'
            },
            {
                path : 'eventos',
                component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/events/Events'),
                children : [
                    {
                        path : '',
                        component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/events/Index.vue'),
                        name: 'back.events.index'
                    },
                    {
                        path : 'crear',
                        component : () => import(/* webpackChunkName: "admin" */ '@/modules/admin/eventos/views/Crear.vue'),
                        name: 'back.events.crear'
                    },
                    {
                        path : ':evento_id/compania',
                        component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/events/Compania.vue'),
                        name: 'back.events.compania',
                        props: true
                    },
                    {
                        path : ':evento_id/editar',
                        component : () => import(/* webpackChunkName: "admin" */ '@/modules/admin/eventos/views/Editar.vue'),
                        name: 'back.events.editar',
                        props: true
                    },
                    {
                        path : ':evento_id/invitaciones-abonados',
                        component : () => import(/* webpackChunkName: "admin" */ '@/modules/admin/events/views/InvitacionesAbonados.vue'),
                        name: 'back.events.invitaciones-abonados',
                        props: true
                    },
                    {
                        path : ':evento_id/sales-ad',
                        component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/events/SalesAd.vue'),
                        name: 'back.events.sales-ad.index',
                        props: true
                    },
                    {
                        path : ':evento_id/puertas',
                        component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/events/Puertas.vue'),
                        name: 'back.events.puertas.index',
                        props: true
                    },
                    {
                        path : ':evento_id/preventa',
                        component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/events/ListadoSolicitudPreventa.vue'),
                        name: 'back.events.preventa.index',
                        props: true
                    },
                    {
                        path : ':id/informe',
                        component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/events/Informe.vue'),
                        name: 'back.events.informe',
                        props: true
                    },
                    {
                        path : ':id/informe/emails',
                        component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/events/EstadisticasEmailsEventos.vue'),
                        name: 'back.events.informe.emails',
                        props: true
                    },
                    {
                        path : ':evento_id/informe/emails/:listado_emails',
                        component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/events/ListadoEmailsEstadisticasEventos.vue'),
                        name: 'back.events.informe.emails.listado',
                        props: true
                    },
                    {
                        path : ':evento_id/sesiones/:sesion_id/configuracion',
                        component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/events/sesiones/Configuracion.vue'),
                        name: 'back.events.sesion.configuracion',
                        props: true
                    },
                    {
                        path : ':evento_id/sesiones/:sesion_id/ventas',
                        component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/events/sesiones/Ventas.vue'),
                        name: 'back.events.ventas',
                        props: true
                    },
                    {
                        path : ':evento_id/sesiones/:sesion_id/venta',
                        component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/events/Venta.vue'),
                        name: 'back.events.venta',
                        props: true
                    },
                    {
                        path : ':evento_id/sesiones/:sesion_id/invitaciones',
                        component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/invitaciones/Invitaciones.vue'),
                        name: 'back.events.invitaciones',
                        props: true
                    },
                    {
                        path : ':evento_id/sesiones/:sesion_id/imprimir-butacas',
                        component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/pegatinas/Zonas.vue'),
                        name: 'back.events.imprimir-pegatinas',
                        props: true
                    },
                    {
                        path : ':evento_id/sesiones/:sesion_id/gestor-de-butacas',
                        component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/events/sesiones/bloquear-asientos/Index.vue'),
                        name: 'back.events.sesion.bloquear-asientos',
                        props: true
                    },
                    {
                        path : ':evento_id/sesiones/:sesion_id/reservas',
                        component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/events/sesiones/reservas/Index.vue'),
                        name: 'back.events.sesion.reservas',
                        props: true
                    },
                    {
                        path : ':evento_id/sesiones/:sesion_id/reservas/:reserva_id',
                        component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/events/sesiones/reservas/Show.vue'),
                        name: 'back.events.sesion.reservas.show',
                        props: true
                    },
                    {
                        path : ':evento_id/sesiones/:sesion_id/informe/control-acceso',
                        component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/events/sesiones/informe/InformeControlDeAccesos.vue'),
                        name: 'back.events.sesion.informe.control-acceso',
                        props: true,
                        beforeEnter: blockTaquilleroVisitante
                    },
                    {
                        path : ':evento_id/codigo/:codigo_evento/sesiones/:sesion_id/control-acceso',
                        component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/events/sesiones/control-acceso/ControlAcceso.vue'),
                        name: 'back.events.sesion.control-acceso',
                        props: true,
                        beforeEnter: blockTaquilleroVisitante
                    },
                    {
                        path : ':evento_id/sesiones/:sesion_id/productos',
                        component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/events/sesiones/productos/Productos'),
                        children: [
                            {
                                path : '',
                                component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/events/sesiones/productos/Index'),
                                name: 'back.events.sesion.productos',
                                props: true
                            },
                        ]
                    },
                    {
                        path : ':evento_id/:sesion_id/codigos-qr',
                        component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/events/sesiones/codigos-qr/CodigosQr.vue'),
                        children: [
                            {
                                path : '',
                                component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/events/sesiones/codigos-qr/Index.vue'),
                                name: 'back.events.sesion.codigos-qr',
                                props: true
                            },
                        ]
                    },
                    {
                        path : ':evento_id/sesiones/:sesion_id/listado-bloqueos',
                        component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/events/sesiones/listado-bloqueos/Index.vue'),
                        name: 'back.events.sesion.listado-bloqueos',
                        props: true
                    },
                    {
                        path: ':evento_id/descuentos',
                        component: () => import(/* webpackChunkName: "admin" */ '@/modules/admin/eventos/descuentos/Index.vue'),
                        name: 'back.events.descuentos.index',
                        props: true,
                    },
                    {
                        path : ':evento_id/campos-personalizados',
                        component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/events/campos-personalizados/Index.vue'),
                        name: 'back.events.fields',
                        props: true
                    },
                    {
                        path : ':evento_id/sesiones/:sesion_id/compradores-permitidos',
                        component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/events/sesiones/compradores-permitidos/CompradoresPermitidos'),
                        children: [
                            {
                                path : '',
                                component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/events/sesiones/compradores-permitidos/Index'),
                                name: 'back.events.sesion.compradores-permitidos'
                            },
                            {
                                path : 'crear',
                                component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/events/sesiones/compradores-permitidos/Crear'),
                                name: 'back.events.sesion.compradores-permitidos.add'
                            }
                        ]
                    }
                ]
            },
            {
                // Sibling redirect for legacy URL — covers bookmarks, external links, etc.
                // Requires getListaId to be set in the store; the app sets it at login.
                path : 'abonados',
                redirect: () => {
                    const id = store.getters.getListaId;
                    if (!id) {
                        // Defensive: si el store no tiene lista_id (ej. login no completado,
                        // reload antes de setLista(), o sesión expirada), evitamos una URL
                        // inválida que Vue Router no puede construir. Mostramos 404 explícita
                        // en vez de caer al home silenciosamente.
                        return { name: '404page' };
                    }
                    return { name: 'back.abonados.index', params: { lista_id: id } };
                },
            },
            {
                // New parent — MainContent asLayout=true, like deportistas (:756-758)
                path : 'abonados/:lista_id',
                component : () => import(/* webpackChunkName: "admin" */ '@/modules/admin/ui/MainContent.vue'),
                props : route => ({ asLayout: true }),
                children : [
                    {
                        path : '',
                        component : () => import(/* webpackChunkName: "admin" */ '@/modules/admin/abonados/views/Index.vue'),
                        name: 'back.abonados.index'
                    },
                    {
                        path: 'familias',
                        component: () => import(/* webpackChunkName: "admin" */ '@/modules/admin/abonados/familias/views/Index.vue'),
                        name: 'back.familias.index',
                        meta: { hideSelect: true },
                    },
                    {
                        path: 'familias/:familia_id',
                        component: () => import(/* webpackChunkName: "admin" */ '@/modules/admin/abonados/familias/views/Show.vue'),
                        name: 'back.familias.show',
                    },
                    {
                        // :lista_id dropped from all child paths below — inherited from parent.
                        path : ':abonado_id',
                        component : () => import(/* webpackChunkName: "admin" */ '@/modules/admin/abonados/views/Show.vue'),
                        name: 'back.abonados.show',
                        props: true
                    },
                    {
                        path : ':abonado_id/editar',
                        component : () => import(/* webpackChunkName: "admin" */ '@/modules/admin/abonados/views/Editar.vue'),
                        name: 'back.abonados.editar',
                        props: true
                    },
                    {
                        path : ':abonado_id/liberar-asiento',
                        component : () => import(/* webpackChunkName: "admin" */ '@/modules/admin/abonados/views/LiberarAsiento.vue'),
                        name: 'back.abonados.liberar.asiento',
                        props: true,
                        meta: { hideSelect: true }
                    },
                    {
                        path : ':abono_id/generar-invitaciones/:event_id/:sesion_id',
                        component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/invitaciones/GenerarInvitaciones.vue'),
                        name: 'back.abonados.generar-invitaciones',
                        props: true,
                        meta: { hideSelect: true }
                    },
                ]
            },
            {
                path : 'envios',
                component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/envios/Envios.vue'),
                children : [
                    {
                        path : '',
                        component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/envios/Index.vue'),
                        name: 'back.envios.index',
                        props: true
                    },
                    {
                        path : ':envio_id',
                        component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/envios/Show.vue'),
                        name: 'back.envios.show',
                        props: true
                    }
                ]
            },
            {
                path : 'simpatizantes',
                component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/simpatizantes/Simpatizantes'),
                children : [
                    {
                        path : '',
                        component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/simpatizantes/Index.vue'),
                        name: 'back.simpatizantes.index'
                    },
                    {
                        path : 'venta',
                        component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/simpatizantes/Venta.vue'),
                        name: 'back.simpatizantes.venta'
                    },
                    {
                        path : 'crear',
                        component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/simpatizantes/Crear.vue'),
                        name: 'back.simpatizantes.crear'
                    },
                    {
                        path : ':simpatizante_id',
                        component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/simpatizantes/Show.vue'),
                        name: 'back.simpatizantes.show',
                        props: true
                    },
                    {
                        path : ':simpatizante_id/editar',
                        component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/simpatizantes/Editar.vue'),
                        name: 'back.simpatizantes.editar',
                        props: true
                    }

                ]
            },
            {
                path : 'taquilleros',
                component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/taquilleros/Taquilleros'),
                children : [
                    {
                        path : '',
                        component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/taquilleros/Index.vue'),
                        name: 'back.taquilleros.index'
                    },
                    {
                        path : 'crear',
                        component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/taquilleros/Crear.vue'),
                        name: 'back.taquilleros.crear'
                    },
                    {
                        path : ':taquillero_id',
                        component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/taquilleros/Show.vue'),
                        name: 'back.taquilleros.show',
                        props: true
                    },
                    {
                        path : ':taquillero_id/editar',
                        component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/taquilleros/Editar.vue'),
                        name: 'back.taquilleros.editar',
                        props: true
                    }
                ]
            },
            {
                path : ':lista_id/frecuencias',
                component : () => import(/* webpackChunkName: "admin" */ '@/modules/admin/bases/categorias/views/FrecuenciasIndex.vue'),
                name: 'back.frecuencias'
            },
            {
                path : ':lista_id/frecuencias/crear',
                component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/frecuencias/Crear.vue'),
                name: 'back.frecuencias.crear'
            },
            {
                path : ':lista_id/deportistas',
                component : () => import(/* webpackChunkName: "admin" */ '@/modules/admin/ui/MainContent.vue'),
                props: route => ({ asLayout: true }),
                children : [
                    {
                        path : '',
                        component : () => import(/* webpackChunkName: "admin" */ '@/modules/admin/bases/views/Index.vue'),
                        name: 'back.bases.index'
                    },
                    {
                        path : 'crear',
                        component : () => import(/* webpackChunkName: "admin" */ '@/modules/admin/bases/crear/views/Index.vue'),
                        name: 'back.bases.crear'
                    },
                    {
                        path : 'renovar',
                        component : () => import(/* webpackChunkName: "admin" */ '@/modules/admin/bases/renovar/views/Index.vue'),
                        name: 'back.bases.renovar',
                        meta: { hideSelect: true }
                    },
                    {
                        path : 'informe',
                        component : () => import(/* webpackChunkName: "admin" */ '@/modules/admin/bases/informe/views/Informe.vue'),
                        name: 'back.bases.informe',
                        props: route => ({ lista_id: route.params.lista_id })
                    },
                    {
                        path : 'informe/categorias',
                        component : () => import(/* webpackChunkName: "admin" */ '@/modules/admin/bases/informe/categorias/views/Index.vue'),
                        name: 'back.bases.informe.categorias',
                        props: route => ({ lista_id: route.params.lista_id })
                    },
                    {
                        path : 'informe/plazos-impagados',
                        component : () => import(/* webpackChunkName: "admin" */ '@/modules/admin/plazos/views/Index.vue'),
                        name: 'back.bases.informe.plazos-impagados',
                        props: route => ({ ...route.params, context: 'bases' })
                    },
                    {
                        path : 'equipos',
                        component : () => import(/* webpackChunkName: "admin" */ '@/modules/admin/bases/equipos/views/EquiposLayout.vue'),
                        children : [
                            {
                                path : '',
                                component : () => import(/* webpackChunkName: "admin" */ '@/modules/admin/bases/equipos/views/Index.vue'),
                                name: 'back.bases.equipos'
                            },
                            {
                                path : 'crear',
                                component : () => import(/* webpackChunkName: "admin" */ '@/modules/admin/bases/equipos/views/Crear.vue'),
                                name: 'back.bases.equipos.crear'
                            },
                            {
                                path : ':equipo_id',
                                component : () => import(/* webpackChunkName: "admin" */ '@/modules/admin/bases/equipos/views/Show.vue'),
                                name: 'back.bases.equipos.show'
                            },
                            {
                                path : ':equipo_id/editar',
                                component : () => import(/* webpackChunkName: "admin" */ '@/modules/admin/bases/equipos/views/Editar.vue'),
                                name: 'back.bases.equipos.update'
                            }
                        ]
                    },
                    {
                        path : 'categorias',
                        component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/bases/categorias/Categorias'),
                        children : [
                            {
                                path : '',
                                component : () => import(/* webpackChunkName: "admin" */ '@/modules/admin/bases/categorias/views/Index.vue'),
                                name: 'back.bases.categorias.index'
                            },
                            {
                                path : 'crear',
                                component : () => import(/* webpackChunkName: "admin" */ '@/modules/admin/bases/categorias/views/Crear.vue'),
                                name: 'back.bases.categorias.crear'
                            },
                            {
                                path : ':categoria_id/resumen',
                                component : () => import(/* webpackChunkName: "admin" */ '@/modules/admin/bases/categorias/views/Resumen.vue'),
                                name: 'back.bases.categorias.resumen',
                            },
                            {
                                path : ':categoria_id/codigos_invitacion',
                                component : () => import(/* webpackChunkName: "admin" */ '@/modules/admin/bases/categorias/codigos_invitacion/Index.vue'),
                                name: 'back.bases.categorias.codigos_invitacion',
                                props: true,
                                meta: { hideSelect: true }
                            }
                        ]
                    },
                    {
                        path : 'indumentarias',
                        component : () => import(/* webpackChunkName: "admin" */ '@/modules/admin/bases/indumentarias/IndumentariaLayout.vue'),
                        children : [
                            {
                                path : '',
                                component : () => import(/* webpackChunkName: "admin" */ '@/modules/admin/bases/indumentarias/Index.vue'),
                                name: 'back.bases.indumentarias.index'
                            },
                            {
                                path : 'crear',
                                component : () => import(/* webpackChunkName: "admin" */ '@/modules/admin/bases/indumentarias/Crear.vue'),
                                name: 'back.bases.indumentarias.crear'
                            },
                            {
                                path : 'inventario',
                                component : () => import(/* webpackChunkName: "admin" */ '@/modules/admin/bases/indumentarias/Inventario.vue'),
                                name: 'back.bases.indumentarias.inventario'
                            },
                            {
                                path : ':indumentaria_id',
                                component : () => import(/* webpackChunkName: "admin" */ '@/modules/admin/bases/indumentarias/Show.vue'),
                                name: 'back.bases.indumentarias.show',
                                props: true
                            },
                            {
                                path : ':indumentaria_id/update',
                                component : () => import(/* webpackChunkName: "admin" */ '@/modules/admin/bases/indumentarias/Editar.vue'),
                                name: 'back.bases.indumentarias.update'
                            },
                        ]
                    },
                    {
                        path : 'campos-personalizados',
                        component : () => import(/* webpackChunkName: "admin" */ '@/modules/admin/campos-personalizados/views/Index.vue'),
                        name: 'back.bases.fields',
                        props: route => ({
                            context: 'bases',
                            entityId: Number(route.params.lista_id)
                        })
                    },
                    {
                        path : 'recogida-indumentarias',
                        component : () => import(/* webpackChunkName: "admin" */ '@/modules/admin/bases/RecogidaIndumentarias.vue'),
                        name: 'back.bases.recogida-indumentarias',
                        props: true
                    },
                    {
                        path : ':base_id',
                        component : () => import(/* webpackChunkName: "admin" */ '@/modules/admin/bases/views/Show.vue'),
                        name: 'back.bases.show',
                        props: true
                    },
                    {
                        path : ':base_id/update',
                        component : () => import(/* webpackChunkName: "admin" */ '@/modules/admin/bases/views/Editar.vue'),
                        name: 'back.bases.update',
                        props: true
                    }
                ]
            },
            {
                path : 'abonos',
                component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/abonos/Abonos'),
                children : [
                    {
                        path : '',
                        component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/abonos/Index.vue'),
                        name: 'back.abonos.index'
                    },
                    {
                        path : 'informe',
                        component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/abonos/Informe.vue'),
                        name: 'back.abonos.informe'
                    },
                    {
                        path : 'precios',
                        component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/abonos/precios/Index.vue'),
                        name: 'back.abonos.precios'
                    },
                    {
                        path : 'precios/grupos',
                        component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/abonos/precios/grupos/Index.vue'),
                        name: 'back.abonos.precios.grupos'
                    },
                    {
                        path : 'precios/grupos/:grupo_id',
                        component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/abonos/precios/grupos/Show.vue'),
                        name: 'back.abonos.precios.grupos.show',
                        props: true
                    },
                    {
                        path : 'precios/:precio_id',
                        component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/abonos/precios/Show.vue'),
                        name: 'back.abonos.precios.descuentos',
                        props: true
                    },
                    {
                        path : 'listado-bloqueos',
                        component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/abonos/listado-bloqueos/Index.vue'),
                        name: 'back.abonos.listado-bloqueos',
                        props: true
                    },
                    {
                        path : 'gestor-de-butacas',
                        component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/abonos/bloqueo-asientos/Index.vue'),
                        name: 'back.abonos.bloquear-asientos',
                        props: true
                    },
                    {
                        path : ':lista_id/campos-personalizados',
                        component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/abonos/campos-personalizados/Index.vue'),
                        name: 'back.abonos.campos-personalizados',
                        props: true
                    },
                    {
                        path : ':lista_id/informe/emails',
                        component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/abonos/EstadisticasEmailsAbonos.vue'),
                        name: 'back.abonos.informe.emails',
                        props: true
                    },
                    {
                        path : ':lista_id/informe/emails/:listado_emails',
                        component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/abonos/ListadoEmailsEstadisticasAbonos.vue'),
                        name: 'back.abonos.informe.emails.listado',
                        props: true,
                        meta: { hideSelect: true }
                    },
                    {
                        path : ':lista_id?/informe/plazos-impagados/',
                        component : () => import(/* webpackChunkName: "admin" */ '@/modules/admin/plazos/views/Index.vue'),
                        name: 'back.abonos.informe.plazos-impagados',
                        props: route => ({ ...route.params, context: 'abonos' })
                    },
                ]
            },
            {
                path : 'comunicados',
                component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/comunicados/Comunicados'),
                children : [
                    {
                        path : '',
                        component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/comunicados/Index'),
                        name: 'back.comunicados.index'
                    },
                    {
                        path : 'crear',
                        component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/comunicados/Crear'),
                        name: 'back.comunicados.crear'
                    },
                    {
                        path : ':comunicado_id/usuarios',
                        component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/comunicados/Usuarios'),
                        name: 'back.comunicados.usuarios',
                        props: true
                    },
                    {
                        path : ':comunicado_id/editar',
                        component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/comunicados/Editar'),
                        name: 'back.comunicados.editar',
                        props: true
                    },
                    {
                        path : ':comunicado_id/estadisticas',
                        component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/comunicados/EstadisticasEmailsComunicados'),
                        name: 'back.comunicados.estadisticas',
                        props: true
                    },
                    {
                        path : ':comunicado_id/estadisticas/:listado_emails',
                        component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/comunicados/ListadoEmailsEstadisticasComunicados'),
                        name: 'back.comunicados.estadisticas.listado',
                        props: true
                    },
                    {
                        path : 'emails',
                        component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/comunicados/Emails'),
                        name: 'back.comunicados.emails.index'
                    },
                    {
                        path : 'recordatorios',
                        component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/comunicados/Recordatorios.vue'),
                        name: 'back.comunicados.recordatorios.index'
                    },
                    {
                        path : 'bases',
                        component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/comunicados/Bases'),
                        name: 'back.comunicados.bases.index'
                    },
                    {
                        path : 'bases/:base_id',
                        component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/comunicados/BasesEmails'),
                        name: 'back.comunicados.bases.emails.index',
                        props: true
                    }
                ]
            },
            // {
            //     path: 'parcelas',
            //     component: () => import(/* webpackChunkName: "admin" */ '@/views/backend/parcelas/Parcelas'),
            //     children: [
            //         {
            //             path: '',
            //             component: () => import(/* webpackChunkName: "admin" */ '@/views/backend/parcelas/Index'),
            //             name: 'back.parcelas.index'
            //         }
            //     ]

            // },
            {
                path : 'plantillas-whatsapp',
                component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/plantillas-whatsapp/PlantillasWhatsapp'),
                children : [
                    {
                        path : '',
                        component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/plantillas-whatsapp/Index'),
                        name: 'back.plantillas-whatsapp.index'
                    },
                    {
                        path : 'crear',
                        component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/plantillas-whatsapp/Crear'),
                        name: 'back.plantillas-whatsapp.crear'
                    },
                    {
                        path : ':plantilla_id/detalle',
                        component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/plantillas-whatsapp/Detalle'),
                        name: 'back.plantillas-whatsapp.show'
                    },
                    {
                        path : ':plantilla_id/editar',
                        component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/plantillas-whatsapp/Editar'),
                        name: 'back.plantillas-whatsapp.editar'
                    }
                ]
            },
            {
                path : 'upselling',
                component : () => import(/* webpackChunkName: "admin" */ '@/modules/admin/upselling/views/Upselling'),
                children : [
                    {
                        path : '',
                        component : () => import(/* webpackChunkName: "admin" */ '@/modules/admin/upselling/views/Index'),
                        name: 'back.upselling.index'
                    },
                    {
                        path : 'crear',
                        component : () => import(/* webpackChunkName: "admin" */ '@/modules/admin/upselling/views/Crear'),
                        name: 'back.upselling.create'
                    },
                    {
                        path : ':campaign_id',
                        component : () => import(/* webpackChunkName: "admin" */ '@/modules/admin/upselling/views/Show'),
                        name: 'back.upselling.show',
                        props: true
                    },
                    {
                        path : ':campaign_id/editar',
                        component : () => import(/* webpackChunkName: "admin" */ '@/modules/admin/upselling/views/Editar'),
                        name: 'back.upselling.update',
                        props: true
                    }
                ]
            },
            {
                path : 'emails',
                component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/campana-emails/CampanaEmails'),
                children : [
                    {
                        path : '',
                        component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/campana-emails/Index'),
                        name: 'back.emails.dashboard'
                    },
                    {
                        path : 'subscriptores',
                        component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/campana-emails/subscriptores/Subscriptores.vue'),
                        children : [
                            {
                                path : '',
                                component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/campana-emails/subscriptores/Index'),
                                name: 'back.emails.subscriptores.index'
                            },
                            {
                                path : 'crear',
                                component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/campana-emails/subscriptores/Crear'),
                                name: 'back.emails.subscriptores.crear'
                            },
                            {
                                path : ':subscriptor_id',
                                component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/campana-emails/subscriptores/Show'),
                                name: 'back.emails.subscriptores.show',
                                props: true
                            },
                            {
                                path : ':subscriptor_id/editar',
                                component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/campana-emails/subscriptores/Editar'),
                                name: 'back.emails.subscriptores.edit'
                            }
                        ]
                    },
                    {
                        path : 'grupos',
                        component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/campana-emails/grupos/Grupos.vue'),
                        children : [
                            {
                                path : '',
                                component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/campana-emails/grupos/Index'),
                                name: 'back.emails.grupos.index'
                            },
                            {
                                path : 'crear',
                                component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/campana-emails/grupos/Crear'),
                                name: 'back.emails.grupos.crear'
                            },
                            {
                                path : ':grupo_id',
                                component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/campana-emails/grupos/Show'),
                                name: 'back.emails.grupos.show'
                            },
                            {
                                path : ':grupo_id/editar',
                                component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/campana-emails/grupos/Editar'),
                                name: 'back.emails.grupos.edit'
                            }
                        ]
                    },
                    {
                        path : 'importaciones',
                        component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/campana-emails/importaciones/Importaciones.vue'),
                        children: [
                            {
                                path: '',
                                component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/campana-emails/importaciones/Index'),
                                name: 'back.emails.importaciones'
                            },
                            {
                                path: 'crear',
                                component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/campana-emails/importaciones/Crear'),
                                name: 'back.emails.importaciones.crear'
                            },
                            {
                                path: ':id',
                                component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/campana-emails/importaciones/Show'),
                                name: 'back.emails.importaciones.show',
                                props: true
                            }
                        ]
                    },
                    {
                        path : 'boletines',
                        component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/campana-emails/boletines/Boletines.vue'),
                        children : [
                            {
                                path : '',
                                component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/campana-emails/boletines/Index'),
                                name: 'back.emails.boletines.index'
                            },
                            {
                                path : 'crear',
                                component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/campana-emails/boletines/Crear'),
                                name: 'back.emails.boletines.crear'
                            },
                            {

                                path : ':id',
                                component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/campana-emails/boletines/BoletinDetalle.vue'),
                                name: 'back.emails.boletines.show',
                                props: true
                            },
                            {

                                path : ':boletin_id/editar',
                                component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/campana-emails/boletines/Editar.vue'),
                                name: 'back.emails.boletines.editar',
                                props: true
                            },
                            {
                                path : ':boletin_id/enviar',
                                component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/campana-emails/boletines/Enviar'),
                                name: 'back.emails.boletines.enviar',
                                props: true
                            },
                        ]
                    },
                    {
                        path : 'remitentes',
                        component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/campana-emails/remitentes/Remitentes.vue'),
                        children : [
                            {
                                path : '',
                                component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/campana-emails/remitentes/Index.vue'),
                                name: 'back.emails.remitentes.index'
                            },
                            {
                                path : '',
                                component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/campana-emails/remitentes/Crear.vue'),
                                name: 'back.emails.remitentes.crear'
                            },
                            {
                                path : ':remitente_id/editar',
                                component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/campana-emails/remitentes/Editar.vue'),
                                name: 'back.emails.remitentes.editar',
                                props: true
                            }
                        ]
                    },
                    {
                        path: 'plantillas',
                        component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/campana-emails/plantilla-boletines/PlantillaBoletines.vue'),
                        children: [
                            {
                                path : '',
                                component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/campana-emails/plantilla-boletines/Index.vue'),
                                name: 'back.emails.plantilla.index',
                            },
                            {
                                path : 'crear',
                                component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/campana-emails/plantilla-boletines/CrearPlantilla.vue'),
                                name: 'back.emails.plantilla.crear',
                            },
                            {
                                path : ':plantilla_id/editar',
                                component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/campana-emails/plantilla-boletines/EditarPlantilla.vue'),
                                name: 'back.emails.plantilla.editar',
                                props: true
                            },
                        ]
                    },
                    {
                        path : 'gestor-de-medios',
                        component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/campana-emails/gestor-de-medios/Index'),
                        name: 'back.emails.gestor-de-medios'
                    },
                    {
                        path : 'informes',
                        component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/campana-emails/informes/Informes.vue'),
                        children : [
                            {
                                path : 'boletines-enviados',
                                component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/campana-emails/informes/BoletinesEnviados'),
                                name: 'back.emails.informes.boletines-enviados'
                            }
                        ]
                    }
                ]
            },
            {
                path : 'acreditaciones',
                component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/acreditaciones/Acreditaciones'),
                children : [
                    {
                        path : '',
                        component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/acreditaciones/Index.vue'),
                        name: 'back.acreditaciones.index',
                        props: true
                    },
                    {
                        path : ':evento_id/crear',
                        component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/acreditaciones/Crear.vue'),
                        name: 'back.acreditaciones.crear',
                        props: true
                    },
                    {
                        path : ':acreditacion_id',
                        component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/acreditaciones/Show.vue'),
                        name: 'back.acreditaciones.show',
                        props: true
                    },
                    {
                        path : ':evento_id/:acreditacion_id/editar',
                        component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/acreditaciones/Editar.vue'),
                        name: 'back.acreditaciones.update',
                        props: true
                    },
                    {
                        path : ':evento_id/:acreditacion_id/activar',
                        component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/acreditaciones/Activar.vue'),
                        name: 'back.acreditaciones.activar',
                        props: true
                    },
                ]
            },
            {
                path : 'facturas',
                component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/facturas/Facturas'),
                children : [
                    {
                        path : '',
                        component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/facturas/Index.vue'),
                        name: 'back.facturas.index'
                    },
                    {
                        path : ':teatro_facturas_comisiones_id',
                        component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/facturas/Show.vue'),
                        name: 'back.facturas.show'
                    }
                ]
            },
            {
                path : 'formularios',
                component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/formularios/Formularios'),
                children : [
                    {
                        path : '',
                        component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/formularios/Index'),
                        name: 'back.formularios.index'
                    },
                    {
                        path : 'crear',
                        component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/formularios/Crear'),
                        name: 'back.formularios.crear'
                    },
                    {
                        path : ':field_id',
                        component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/formularios/Editar'),
                        name: 'back.formularios.editar',
                        props: true
                    }
                ]
            },

            {
                path : 'campana-abonos',
                component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/campana-abonos/CampanaAbonos'),
                children : [
                    {
                        path : '',
                        component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/campana-abonos/Index'),
                        name: 'back.campana-abonos.index'
                    },
                ]
            },
            {
                path : 'compania-eventos',
                component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/compania-eventos/CompaniaEventos'),
                children : [
                    {
                        path : '',
                        component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/compania-eventos/Index'),
                        name: 'back.compania-eventos.index'
                    },
                    {
                        path : 'crear',
                        component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/compania-eventos/Crear'),
                        name: 'back.compania-eventos.crear'
                    },
                    {
                        path : ':compania_id',
                        component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/compania-eventos/Editar'),
                        name: 'back.compania-eventos.editar'
                    },
                    {
                        path : ':compania_id/registros-verifactu',
                        component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/compania-eventos/RegistrosVerifactu.vue'),
                        name: 'back.compania-eventos.registros-verifactu',
                        props: true
                    },
                ]
            },
            {
                path : 'productos',
                component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/productos/Productos'),
                children : [
                    {
                        path : '',
                        component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/productos/Index'),
                        name: 'back.productos.index'
                    },
                    {
                        path : 'crear',
                        component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/productos/Crear'),
                        name: 'back.productos.crear'
                    },
                    {
                        path : 'categorias',
                        component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/productos/categorias/Categorias.vue'),
                        children : [
                            {
                                path : '',
                                component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/productos/categorias/Index'),
                                name: 'back.productos.categorias'
                            },
                            {
                                path : 'ordenar',
                                component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/productos/categorias/Ordenar'),
                                name: 'back.productos.categorias.ordenar'
                            }
                        ]
                    },
                    {
                        path : ':product_id',
                        component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/productos/Editar'),
                        name: 'back.productos.editar'
                    }
                ]
            },
            {
                path : 'etiquetas-bloqueos',
                component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/etiquetas-bloqueos/EtiquetasBloqueos'),
                children : [
                    {
                        path : '',
                        component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/etiquetas-bloqueos/Index'),
                        name: 'back.etiquetas-bloqueos.index'
                    }
                ]
            },
            {
                path : 'configuracion',
                component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/configuracion/Configuracion'),
                children : [
                    {
                        path : '',
                        component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/configuracion/Index'),
                        name: 'back.configuracion.index'
                    }
                ]
            },
            {
                path : 'conf-deportistas',
                component : () => import(/* webpackChunkName: "admin" */ '@/modules/admin/configuracion/deportistas/Index'),
                name: 'back.deportistas.index'
            },
            {
                path : 'preguntas-frecuentes',
                component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/faqs/Faqs'),
                children : [
                    {
                        path : '',
                        component : () =>  import(/* webpackChunkName: "admin" */ '@/views/backend/faqs/Index'),
                        name: 'back.faqs.index'
                    },
                    {
                        path : ':faq_id',
                        component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/faqs/Show'),
                        name: 'back.faqs.show',
                        props: true
                    },
                ]
            },
            {
                path : 'liquidaciones-abonos',
                component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/liquidaciones/abonos/LiquidacionesAbonos'),
                children : [
                    {
                        path : '',
                        component : () =>  import(/* webpackChunkName: "admin" */ '@/views/backend/liquidaciones/abonos/Index'),
                        name: 'back.liquidaciones.abonos.index'
                    },
                    {
                        path : 'crear',
                        component : () =>  import(/* webpackChunkName: "admin" */ '@/views/backend/liquidaciones/abonos/CrearLiquidacion'),
                        name: 'back.liquidaciones.abonos.crear'
                    }
                ]
            },
            {
                path : 'liquidaciones-cantera',
                component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/liquidaciones/bases/LiquidacionesBases'),
                children : [
                    {
                        path : '',
                        component : () =>  import(/* webpackChunkName: "admin" */ '@/views/backend/liquidaciones/bases/Index'),
                        name: 'back.liquidaciones.bases.index'
                    },
                    {
                        path : 'crear',
                        component : () =>  import(/* webpackChunkName: "admin" */ '@/views/backend/liquidaciones/bases/CrearLiquidacion'),
                        name: 'back.liquidaciones.bases.crear'
                    },
                    {
                        path : 'crear',
                        component : () =>  import(/* webpackChunkName: "admin" */ '@/views/backend/liquidaciones/parcelas/CrearLiquidacion'),
                        name: 'back.liquidaciones.parcelas.crear'
                    }
                ]
            },
            {
                path : 'liquidaciones-parcelas',
                component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/liquidaciones/parcelas/LiquidacionesParcelas'),
                children : [
                    {
                        path : '',
                        component : () =>  import(/* webpackChunkName: "admin" */ '@/views/backend/liquidaciones/parcelas/Index'),
                        name: 'back.liquidaciones.parcelas.index'
                    }
                ]
            },
            {
                path : 'liquidaciones-eventos',
                component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/liquidaciones/eventos/LiquidacionesEventos'),
                children : [
                    {
                        path : '',
                        component : () =>  import(/* webpackChunkName: "admin" */ '@/views/backend/liquidaciones/eventos/Index'),
                        name: 'back.liquidaciones.eventos.index'
                    },
                    {
                        path : 'crear',
                        component : () =>  import(/* webpackChunkName: "admin" */ '@/views/backend/liquidaciones/eventos/CrearLiquidacion'),
                        name: 'back.liquidaciones.eventos.crear'
                    }
                ]
            },
            {
                path : 'liquidaciones-productos',
                component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/liquidaciones/productos/LiquidacionesProductos'),
                children : [
                    {
                        path : '',
                        component : () =>  import(/* webpackChunkName: "admin" */ '@/views/backend/liquidaciones/productos/Index'),
                        name: 'back.liquidaciones.productos.index'
                    },
                    {
                        path : 'crear',
                        component : () =>  import(/* webpackChunkName: "admin" */ '@/views/backend/liquidaciones/productos/CrearLiquidacion'),
                        name: 'back.liquidaciones.productos.crear'
                    }
                ]
            },
            {
                path : 'packs-eventos',
                component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/packs-events/PacksEvents'),
                children : [
                    {
                        path : '',
                        component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/packs-events/Index.vue'),
                        name: 'back.packs-events.index'
                    },
                    {
                        path : 'crear',
                        component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/packs-events/Create.vue'),
                        name: 'back.packs-events.create'
                    },
                    {
                        path : ':pack_id',
                        component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/packs-events/Show.vue'),
                        name: 'back.packs-events.show',
                        props: true
                    },
                    {
                        path : ':pack_id/precios',
                        component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/packs-events/Precios.vue'),
                        name: 'back.packs-events.show.precios',
                        props: true
                    },
                    {
                        path : ':pack_id/editar',
                        component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/packs-events/Edit.vue'),
                        name: 'back.packs-events.show.editar',
                        props: true
                    }
                ]
            },
            {
                path : 'mensajes',
                component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/mensajes/Mensajes'),
                children : [
                    {
                        path : '',
                        component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/mensajes/Index'),
                        name: 'back.mensajes.index'
                    },
                    {
                        path : 'crear',
                        component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/mensajes/Crear'),
                        name: 'back.mensajes.crear'
                    },
                    {
                        path : ':incidencia_id',
                        component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/mensajes/Show'),
                        name: 'back.mensajes.show'
                    }
                ]
            },
            {
                path : ':lista_id/usuarios',
                component : () => import(/* webpackChunkName: "admin" */ '@/modules/admin/usuarios/UsuariosLayout'),
                children : [
                    {
                        path : ':user_id',
                        component : () => import(/* webpackChunkName: "admin" */ '@/views/backend/usuarios/Show'),
                        name: 'back.usuarios.show-user',
                        props: true
                    },
                ]
            },
            {
                path: 'parcelas',
                component: () => import(/* webpackChunkName: "admin" */ '@/views/backend/parcelas/Parcelas'),
                children: [
                    {
                        path: '',
                        component: () => import(/* webpackChunkName: "admin" */ '@/views/backend/parcelas/Index'),
                        name: 'back.precios.parcelas.index'
                    },
                    {
                        path: 'venta',
                        component: () => import(/* webpackChunkName: "admin" */ '@/views/backend/parcelas/Venta'),
                        name: 'back.venta.parcelas',
                    },
                    {
                        path: 'parcelas-vendidas',
                        component: () => import(/* webpackChunkName: "admin" */ '@/views/backend/parcelas/ListadoParcelasVendidas'),
                        name: 'back.listado.parcelas.vendidas',
                    },
                    {
                        path: 'informe',
                        component: () => import(/* webpackChunkName: "admin" */ '@/views/backend/parcelas/Informe'),
                        name: 'back.listado.parcelas.informe',
                    },
                    {
                        path: ':precio_id',
                        component: () => import(/* webpackChunkName: "admin" */ '@/views/backend/parcelas/Show'),
                        name: 'back.precios.parcelas.show',
                        props: true
                    },
                ]
            }
        ]
    },
    {
        path : '/superadmin/svg/edit',
        component : () => import('@/views/superadmin/svg/EditSvg.vue'),
        name : 'superadmin.svg.edit'
    },
    {
        path : '/superadmin/imports/abonados/excel',
        component : () => import("@/views/superadmin/imports/AbonadosFromExcel"),
        name : 'superadmin.imports.abonados.excel'
    },
    {
        path : '/superadmin/imports/abonados/lista',
        component : () => import("@/views/superadmin/imports/AbonadosFromLista"),
        name : 'superadmin.imports.abonados.lista'
    },
    {
        path : '/superadmin/ocultar-butacas',
        component : () => import("@/views/superadmin/ocultar_butacas/OcultarButacas"),
        name : 'superadmin.butacas.ocultar'
    },
    {
        path: '/404',
        component : () => import("@/views/frontend/404/Index"),
        name: '404page'
    },
    {
        path: '/*',
        component : () => import("@/views/frontend/404/Index"),
        name: 'error404'
    }

];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return { x: 0, y: 0 }
        }
    }
})

export default router
